import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
  slots: {
    base: 'relative',
    imageStyle: 'max-sm:min-h-[calc(100vh-6rem)] sm:aspect-[1.2] lg:aspect-[16/9] w-full h-full object-cover',
    contentContainer: 'absolute bottom-2 right-2 left-2 lg:bottom-4 lg:left-4 p-2 lg:p-4 bg-white rounded-m lg:rounded-l max-w-[52rem]',
    contentStyle: 'mt-1'
  }
})

export type SingleImageVariants = VariantProps<typeof styles>;
